import { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'utils/axios';
import useAuth from 'hooks/useAuth';

// Whether the menu shows Assessments: false only when none of the user's groups is at a school that has assessments
// on. True until the API answers, and still true if the check fails, so a slow or broken check never hides the page.
// schoolsOff: not enabled because the user's assessment groups are all at schools that have them Off.
const AssessmentsContext = createContext({ assessmentsEnabled: true, schoolsOff: false });

export function AssessmentsProvider({ children }) {
    const { isLoggedIn } = useAuth();
    const [assessmentsEnabled, setAssessmentsEnabled] = useState(true);
    const [schoolsOff, setSchoolsOff] = useState(false);

    useEffect(() => {
        setAssessmentsEnabled(true);
        setSchoolsOff(false);
        // The check needs a signed-in user. Signed out, a 401 would send the login page back to itself in a loop.
        if (!isLoggedIn) {
            return;
        }
        axios
            .get('/assessments/enabled', { skipAuthRedirect: true })
            .then(({ data }) => {
                setAssessmentsEnabled(data?.enabled !== false);
                setSchoolsOff(data?.schoolsOff === true);
            })
            .catch((error) => console.error('Error checking assessments:', error));
    }, [isLoggedIn]);

    return <AssessmentsContext.Provider value={{ assessmentsEnabled, schoolsOff }}>{children}</AssessmentsContext.Provider>;
}

AssessmentsProvider.propTypes = {
    children: PropTypes.node
};

export default AssessmentsContext;
